const generalConfig = {
  apiCode: 'dj458ghj57fdjrf8+8#s-,fff',
  baseUrl: 'https://www.nonnenmann-mold-solution.com',
  apiBaseUrl: 'https://www.nonnenmann-mold-solution.com/api',
  defaultLocale: 'zh',
};

export default generalConfig;
